import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { WeeeFeedbackService } from '~shared/modules/weee-landing-page/services/weee-feedback.service';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import get from 'lodash.get';
import { RouterStateUrl } from '~core/store';
import {
  SubmitWeeeUserSelection,
  SubmitWeeeUserSelectionError,
  SubmitWeeeUserSelectionSuccess,
  WeeeFeedabackActionTypes,
} from '~shared/modules/weee-landing-page/store/weee-feedback/weee-feedaback.actions';
import { WeeeError, WeeeSuccess } from '~shared/modules/weee-landing-page/models/weee-feedback.model';
import { WEEE_LANDING_PAGE } from '~shared/constants';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class WeeeFeedabackEffects {
  @Effect()
  submitUserSelectionByRouter$: Observable<Action> = this.actions$.pipe(
    ofType(ROUTER_NAVIGATED),
    map((action: RouterNavigatedAction) => get(action, 'payload.routerState', {})),
    map(({ url, queryParams }: RouterStateUrl) => ({ url, queryParams })),
    filter((routerState: any) => {
      return routerState.url.startsWith(`/${WEEE_LANDING_PAGE}`);
    }),
    map(({ queryParams }) => ({
      id: queryParams.id,
      action: queryParams.action,
    })),
    map((params) => new SubmitWeeeUserSelection(params))
  );

  @Effect()
  submitUserSelection$: Observable<Action> = this.actions$.pipe(
    ofType(WeeeFeedabackActionTypes.SUBMIT_WEEE_USER_SELECTION),
    filter(() => isPlatformBrowser(this.platformId)),
    map((action: SubmitWeeeUserSelection) => action.payload),
    switchMap((params) =>
      this.weeeFeedbackService.submitUserSelection(params).pipe(
        map((payload: WeeeSuccess) => new SubmitWeeeUserSelectionSuccess(payload)),
        catchError((error: WeeeError) => of(new SubmitWeeeUserSelectionError(error)))
      )
    )
  );

  constructor(
    private weeeFeedbackService: WeeeFeedbackService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private actions$: Actions
  ) {}
}
